import React from 'react';
import PropTypes from 'prop-types'

import {
    rendererFn,
    Block,
} from 'medium-draft';

import {findEmbedArg} from './vkEmbed';

import Player from '../player/Player'

import PopupMeta from '../media/PopupMeta';
import GallerySlider from './GallerySlider/GallerySlider';

const AtomicBlock = (props) => {
    if (props.block.getEntityAt(0) === null) {
        return null;
    }
    const {blockProps, block} = props;
    const content = blockProps.getEditorState().getCurrentContent();
    const entity = content.getEntity(block.getEntityAt(0));
    const data = entity.getData();
    const type = entity.getType();
    
    if (blockProps.components[type]) {
        const AtComponent = blockProps.components[type];
        return (
            <div className={`md-block-atomic-wrapper md-block-atomic-wrapper-${type}`}>
                <AtComponent data={data}/>
            </div>);
    }
    
    return <p>Block of type <b>{type}</b> is not supported.</p>;
};

export class AtomicEmbedComponent extends React.Component {
    
    static propTypes = {
        data: PropTypes.object.isRequired,
    }
    
    componentDidMount() {
        this.setEmbedScript();
    }
    
    componentDidUpdate(prevProps, prevState) {
        this.setEmbedScript();
    }
    
    setEmbedScript() {
        if (this.props.data.hasOwnProperty('provider_name')) {
            switch (this.props.data.provider_name) {
            case 'Twitter':
                this.renderTweet();
                break;

            case 'Instagram':
                this.renderInstagram();
                break;

            case 'Vk':
                this.renderVk();
                break;

            case 'Facebook':
                break;

            case 'playbuzz':
                this.renderPlaybuzzScript();
                break;
            default:
                break;
            }
        }
    }
    
    getTwitterScript() {
        const script = document.createElement('script');
        script.async = 1;
        script.src = '//platform.twitter.com/widgets.js';
        script.onload = () => {
            window.twttr.widgets.load()
        };
        document.body.appendChild(script);
    }
    
    getInstagramScript() {
        const script = document.createElement('script');
        script.async = 1;
        script.src = '//platform.instagram.com/en_US/embeds.js';
        script.onload = () => {
            window.instgrm.Embeds.process();
        };
        document.body.appendChild(script);
    }
    
    getPlaybuzzScript() {
        const script = document.createElement('script');
        script.async = 1;
        script.src = '//cdn.playbuzz.com/widget/feed.js';
        document.body.appendChild(script);
    }
    
    renderTweet() {
        if (window.twttr) {
            window.twttr.widgets.load()
        } else {
            this.getTwitterScript();
        }
    }
    
    renderInstagram() {
        if (window.instgrm) {
            window.instgrm.Embeds.process();
        } else {
            this.getInstagramScript();
        }
    }
    
    renderPlaybuzzScript() {
        if (!window.PlayBuzz) {
            this.getPlaybuzzScript();
        }
    }
    
    renderVk() {
        const args = findEmbedArg(this.props.data.html);
        const vkWrapper = document.getElementById(args.element_id);
        setTimeout(function() {
            if (vkWrapper.children.length) {
                return;
            }
            const script = document.createElement('script');
            script.async = 1;
            script.src = '//vk.com/js/api/openapi.js?150';
            script.onload = () => {
                if (vkWrapper.children.length) {
                    return;
                }
                window.VK.Widgets.Post(args.element_id, args.owner_id, args.post_id, args.hash, {width: 500})
            };
            document.body.appendChild(script);
        }, 500);
    }
    
    render() {
        const {html} = this.props.data;
        return (
            <div className="md-block-atomic-embed">
                <div dangerouslySetInnerHTML={{__html: html}}/>
            </div>
        )
    }
}

export class AtomicEmptyComponent extends React.Component {
    render() {
        return (<div/>)
    }
}

export class AtomicVideoComponent extends React.Component {
    
    static propTypes = {
        data: PropTypes.object.isRequired,
    };
    
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            edit: false
        }
    }
    
    componentDidMount() {
        this.setState({
            id: null,
            open: false,
            edit: false
        })
    }
    
    render() {
        const {location} = this.props.data;
        const config = {
            poster: this.props.data.preview || '',
            sources: [{src: location, type: 'video/mp4'}],
            autoplay: false,
            edit: this.props.data.edit ? this.props.data.edit : false
        };
        if (this.props.data.id) {
            config.id = this.props.data.id;
        }
        return (<div>
            {this.state.open &&
            <PopupMeta
                id={this.state.id}
                closeDialogHandle={()=>{
                    this.setState({open: false})
                }}
            />
            }
            <Player
                config={config}
                edit={item => {
                    this.setState({
                        open: true,
                        id: item.id
                    });
                }}
            /></div>)
    }
}

export class AtomicGallerySlider extends React.Component {
    render() {
        const slides = this.props.block.getData().get('slides');
        return (
            <div>
                { slides.map(slide => (
                    <img src={ slide.get('previewUrl') } alt="#" />
                )) }
            </div>
        );
    }
}



export function renderer(setEditorState, getEditorState) {
    const atomicRenderers = {
        embed: AtomicEmbedComponent,
        video: AtomicVideoComponent,
        empty: AtomicEmptyComponent,
        slider: GallerySlider
    };
    
    const rFnOld = rendererFn(setEditorState, getEditorState);
    
    const rFnNew = (contentBlock) => {
        const type = contentBlock.getType();
        switch (type) {
        case Block.ATOMIC:
            return {
                component: AtomicBlock,
                editable: false,
                props: {
                    components: atomicRenderers,
                    getEditorState,
                },
            };

        default:
            return rFnOld(contentBlock);
        }
    };
    
    return rFnNew;
}



// WEBPACK FOOTER //
// src/components/editor/AtomicBlock.js